<template>
  <div class="footer-wrapper">
    <div class="wrap">
      <div class="con">
        <!-- <ul class="list"> -->
          <!-- <li>
            <img src="/static/img/ic_tel.png" alt="">
            <div>
              <p>{{config_info.service_macao_number_title}}</p>
              <p>{{config_info.service_macao_number}}</p>
            </div>
          </li> -->
          <!-- <li>
            <img src="/static/img/ic_tel.png" alt="">
            <div>
              <p>客服电话</p>
              <p>{{config_info.service_philippines_number}}</p>
            </div>
          </li> -->
          <!-- <li>
            <img src="/static/img/ic_zhuanyuan.png" alt="">
            <div>
              <p>{{config_info.service_qq}}</p>
              <a :href="config_info.service_kefu_url_1">{{config_info.service_kefu_info_1}}</a>
            </div>
          </li>
          <li>
            <img src="/static/img/ic_zhuanyuan.png" alt="">
            <div>
              <p>{{config_info.service_wechat}}</p>
              <a :href="config_info.service_kefu_url_2">{{config_info.service_kefu_info_2}}</a>
            </div>
          </li> -->
          <!-- <li>
            <img src="/static/img/ic_gov.png" alt="">
            <div>
              <p>持有政府牌照</p>
              <p>Government licenses</p>
            </div>
          </li> -->
        <!-- </ul> -->
        <img class="other" src="/static/img/f_logo.png" alt="">
      </div>

      <p class="copyright">{{config_info.site_copyright}}</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'v-footer',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['config_info', 'config_foot'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .footer-wrapper
    background #efefef
    width 100%
    margin-top 30px
    border-top solid 2px #dcdcdc
    .wrap
      width 1000px
      margin 0 auto
      overflow hidden
      padding 34px 0 66px
      border-bottom solid 1px #dcdcdc
      .con
        display flex
        align-items center
        justify-content space-between
        margin-bottom 30px
        .list
          flex 1
          display flex
          margin-right 30px
          align-items center
          justify-content space-between
          & > li
            display inline-flex
            font-size 14px
            color #222222
            align-items center
            width 150px
            word-break break-all
            & > img
              display block
            & > div
              margin-left 20px
              & > p:first-child
                margin-bottom 9px
        .other
          width 500px
          height 34px
          margin: 0 auto;
    .copyright
      text-align center
      padding-top 25px
      font-size 14px
      color #222222
    .linkUl
      margin 0 auto
      width 780px
      li
        padding 0 5px
        float left
        a
          color #999
          font-size 12px

</style>



// WEBPACK FOOTER //
// footer.vue?e9206810